import moment from 'moment';
import { saveAs } from 'file-saver';
import { takeLatest, put, select } from 'redux-saga/effects';
import { getRequest, handleSagaError } from '../../../utilities/requests';
import {
  LOAD_TRANSACTIONS,
  setTransactionData,
  loadTransactionFailure,
  DOWNLOAD_CSV,
  CHANGE_SORT_ORDER
} from './reducer/transactions';
import {
  SET_SEARCH_FILTER,
  SET_COMMISSION_STATUS_FILTER,
  SET_CALENDAR_SAGA,
  CLEAR_CALENDAR_FILTER,
  SET_PER_PAGE_FILTER,
  CHANGE_PAGINATOR_PAGE
} from './reducer/filters';

function* transactionFilters() {
  const search = yield select(
    state => state.merchants.merchantTransactions.filters.search
  );
  const status = yield select(
    state => state.merchants.merchantTransactions.filters.commissionStatus
  );
  const per_page = yield select(
    state => state.merchants.merchantTransactions.filters.perPage
  );
  const page = yield select(
    state => state.merchants.merchantTransactions.filters.currentPage
  );
  const orderBy = yield select(
    state => state.merchants.merchantTransactions.transactions.orderBy
  );
  const orderDirection = yield select(
    state => state.merchants.merchantTransactions.transactions.orderDirection
  );
  const startDate = yield select(
    state => state.merchants.merchantTransactions.filters.startDate
  );
  const endDate = yield select(
    state => state.merchants.merchantTransactions.filters.endDate
  );

  const config = {
    per_page,
    page
  };
  if (startDate && endDate) {
    config.start_date = startDate;
    config.end_date = endDate;
  }
  Object.assign(config, {
    search,
    status,
    order_by: orderBy,
    order_direction: orderDirection
  });
  return config;
}

function* handleLoadTransactions() {
  try {
    const url = '/commissions';
    const params = yield transactionFilters();
    const response = yield getRequest(url, params);
    yield put(setTransactionData(response.data));
  } catch (error) {
    yield handleSagaError(
      error,
      'There was an error loading transactions',
      loadTransactionFailure
    );
  }
}

export function* loadTransactionsSaga() {
  yield takeLatest(
    [
      LOAD_TRANSACTIONS,
      CHANGE_PAGINATOR_PAGE,
      SET_SEARCH_FILTER,
      SET_COMMISSION_STATUS_FILTER,
      SET_CALENDAR_SAGA,
      CLEAR_CALENDAR_FILTER,
      SET_PER_PAGE_FILTER,
      CHANGE_SORT_ORDER
    ],
    handleLoadTransactions
  );
}

function* handleDownloadCsv() {
  // handle filters first
  const config = yield transactionFilters();
  try {
    const url = '/commissions.csv';
    const response = yield getRequest(url, config, { responseType: 'blob' });
    const time = moment().format('Y-MM-D');
    saveAs(response.data, `transactions-${time}.csv`);
  } catch (error) {
    yield handleSagaError(
      error,
      'Unable to download transactions at this time. Please try again later.'
    );
  }
}

export function* downloadCsvSaga() {
  yield takeLatest(DOWNLOAD_CSV, handleDownloadCsv);
}
